module.exports = __webpack_public_path__ + "img/antes_despues_108.f2d25eb8.png";